import angular from 'angular';

export default class LocationsMapController {
    constructor(
        locationConfig,
        $scope,
        locationFilter,
        locationConfigStorage,
        mapManager,
        $routeParams,
        geoLocator
    ) {
        locationConfigStorage.setLocationConfig(locationConfig);

        this.locationConfigStorage = locationConfigStorage;
        this.locationConfig = locationConfig;
        this.locationFilter = locationFilter;
        this.mapManager = mapManager;
        this.$routeParams = $routeParams;
        this.geoLocator = geoLocator;

        this.locations = angular.copy(this.locationConfigStorage.getLocationConfig().locations);
        this.filter = this.buildFilter();
        this.selectedLocation = null;
        this.processingLocations = false;
        this.userCountryCode = null;

        const unwatchFilter = $scope.$watch(
            () => this.filter,
            (newValue) => {
                if (angular.isDefined(newValue) && newValue !== null) {
                    this.processingLocations = true;
                    this.locations = this.locationFilter.filterMatchingLocations(newValue);
                    this.mapManager.updateCluster().finally(() => {
                        this.processingLocations = false;
                    });
                }
            },
            true
        );

        $scope.$on('$destroy', () => {
            unwatchFilter();
        });

        this.tryDetectUserCountry();
    }

    showInfoWindowByMarker(event, self, location) {
        self.showInfoWindow(self, location, this);
    }

    showInfoWindowByLocation(location) {
        this.showInfoWindow(this, location, location.id.toString());
    }

    showInfoWindow(self, location, markerIdentifier) {
        self.selectedLocation = location;
        self.mapManager.showInfoWindow(markerIdentifier);
    }

    getIcon(location) {
        return {
            url: location.image,
            origin: [0, 0],
            anchor: [15, 40],
            size: [60, 80],
            scaledSize: [30, 40],
        };
    }

    getRootPayCategories() {
        return this.locationConfigStorage
            .getLocationConfig()
            .pay_categories.filter((category) => category.root_id === category.id);
    }

    buildFilter() {
        let services = angular.copy(
            this.locationConfigStorage.getLocationConfig().services
        );
        let payCategories = this.getRootPayCategories();

        if (angular.isDefined(this.$routeParams['services[]'])) {
            const servicesData = this.$routeParams['services[]'];
            if (angular.isArray(servicesData)) {
                services = servicesData;
            } else {
                services = [servicesData];
            }
            payCategories = [];
        }

        return {
            text: null,
            services: services,
            payCategories: payCategories,
            bounds: null,
        };
    }

    tryDetectUserCountry() {
        this.geoLocator.getUserCountryBounds().then((geoData) => {
            this.applyUserCountryBounds(geoData);
        }).catch(() => {
        });
    }

    applyUserCountryBounds(geoData) {
        const { bounds, countryCode } = geoData || {};

        if (!bounds) {
            return;
        }

        this.filter = this.filter || {};
        this.filter.bounds = bounds;
        this.userCountryCode = countryCode || null;

        this.mapManager.fitBounds(bounds);
    }
}

LocationsMapController.$inject = [
    'locationConfig',
    '$scope',
    'locationFilter',
    'locationConfigStorage',
    'mapManager',
    '$routeParams',
    'geoLocator',
];
